import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="/images/logo.avif" 
              alt="CBL Ar Condicionados Logo" 
              className="h-14 w-14 object-contain rounded-full"
            />
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-orange-500">CBL</span>
              <span className="text-xs text-gray-600 -mt-1">Ar Condicionados</span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-6">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/') ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/instalacao" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/instalacao') ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
              }`}
            >
              Instalação
            </Link>
            <Link 
              to="/conserto" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/conserto') ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
              }`}
            >
              Conserto
            </Link>
            <Link 
              to="/higienizacao" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/higienizacao') ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
              }`}
            >
              Higienização
            </Link>
            <Link 
              to="/sobre" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/sobre') ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
              }`}
            >
              Sobre nós
            </Link>
            <Link 
              to="/galeria" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/galeria') ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
              }`}
            >
              Galeria
            </Link>
            <Link 
              to="/contato" 
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/contato') ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
              }`}
            >
              Contato
            </Link>
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a 
              href="https://wa.me/5541996365014?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-medium hover:shadow-lg transition-all cursor-pointer whitespace-nowrap text-sm flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Solicitar Orçamento
            </a>
          </div>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="py-2 text-gray-700 hover:text-orange-500 cursor-pointer" onClick={() => setIsMenuOpen(false)}>Home</Link>
            <Link to="/instalacao" className="py-2 text-gray-700 hover:text-orange-500 cursor-pointer" onClick={() => setIsMenuOpen(false)}>Instalação</Link>
            <Link to="/conserto" className="py-2 text-gray-700 hover:text-orange-500 cursor-pointer" onClick={() => setIsMenuOpen(false)}>Conserto</Link>
            <Link to="/higienizacao" className="py-2 text-gray-700 hover:text-orange-500 cursor-pointer" onClick={() => setIsMenuOpen(false)}>Higienização</Link>
            <Link to="/sobre" className="py-2 text-gray-700 hover:text-orange-500 cursor-pointer" onClick={() => setIsMenuOpen(false)}>Sobre nós</Link>
            <Link to="/galeria" className="py-2 text-gray-700 hover:text-orange-500 cursor-pointer" onClick={() => setIsMenuOpen(false)}>Galeria</Link>
            <Link to="/contato" className="py-2 text-gray-700 hover:text-orange-500 cursor-pointer" onClick={() => setIsMenuOpen(false)}>Contato</Link>
            <a 
              href="https://wa.me/5541996365014?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-2 px-5 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-medium text-center cursor-pointer whitespace-nowrap"
            >
              Solicitar Orçamento
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}